declare var HierarchicalDiagram: any;

namespace Matrix.Dashboards {

    export interface HierarchicalDiagramWidgetOptions extends IWidgetOptions {
        DatasetCode: string;
        LabelField: string;
        KeyField: string;
        ParentKeyField?: string;
        ClickUrl?: string;
        BackgroundColor?: string;
        NodeBackgroundColorField?: string;
        NodeFontColorField?: string;
        NodeBackgroundColor?: string;
        NodeFontColor?: string;
        NodeFontSize?: number;
        NodePadding?: number;
        DisplayOverview: boolean;
        OpenUrlInNewTab: boolean;
        GraphTheme: string;
    }


    @Serenity.Decorators.registerClass('Matrix.Dashboards.HierarchicalDiagramWidget')
    export class HierarchicalDiagramWidget extends Serenity.Widget<HierarchicalDiagramWidgetOptions> {

        private _ = go.GraphObject.make;
        private data: any[];
        private diagram: go.Diagram;
        private graphTheme: Visualizer.GraphThemeRow;

        constructor(element: JQuery, opt: HierarchicalDiagramWidgetOptions) {
            super(element, opt);

            if (!this.options.DatasetCode) {
                renderSelectDatasetMessage(this.element, this.options.__designer);
                return;
            }

            element.html('<div class="s-visualizer-loader"></div>');

            (go as any).licenseKey = "2bf843e5b46658c511d35a25403e7efb0bab2d67cb854af5595317f2ed587a0425c9bb285184db9086fb4cf51b2ac98bd8c63b2d934e0338e761d4df41b0d6a9b76227b3175d428dac0073c69da979a3f87c71fac7e027a2897889a2edaec69b5abaa1d05ada08ee797e0663067fbd5ab4fad973e602cf506b6c";

            Matrix.Visualizer.GraphThemeService.Retrieve({ EntityId: this.options.GraphTheme ?? "Default" }, r => {
                this.graphTheme = r.Entity;
            }, {
                error: () => {
                    this.graphTheme = {
                        BackgroundColour: '#121b28',
                        EdgeColour: '#696969',
                        NodeColour: '#121b28',
                        LeafNodeColour: '#121b28',
                        RootNodeColour: '#ffa600',
                        NodeTextColour: '#fff',
                        NodeBorderColour: '#ffa600',
                        HighlightColour: '#fff'
                    };
                },
                blockUI: false
            }).always(_ => {
                this.refresh();
                Q.LayoutTimer.onWidthChange(() => element[0], () => this.resize());
            });
        }

        resize() {
            if (this.diagram) {
                Q.debounce(() => {
                    this.diagram.animationManager.isInitial = false;
                    this.buildDiagramModelWithData();
                }, 500)();
            }
        }

        onNodeClick(e: go.DiagramEvent) {
            const lastInput = this.diagram.lastInput;
            if (lastInput.control || lastInput.alt)
                return
            
            const data = e.subject.part.data;
            let url = this.options.ClickUrl;

            if (!url || !data)
                return

            url = Q.microFormat(url, data, {
                handler: TemplateUrlFormatter.microFormatUrlHandler
            });

            if (url && Q.startsWith(url, '~/'))
                url = Q.resolveUrl(url);

            if (!url)
                return;

            window.open(Q.resolveUrl(url), this.options.OpenUrlInNewTab ? "_blank" : "_self");
        }

        protected refresh() {
            DatasetService.Fetch({
                DatasetCode: this.options.DatasetCode,
                Params: this.options.__getDatasetParams()
            },
                (response) => {
                    let data: any[] = response.Data ?? [];
                    if (!Q.isArray(data))
                        data = [data];

                    for (var i = 0; i < data.length; i++) {
                        if (data[i][this.options.ParentKeyField] === null) {
                            delete data[i][this.options.ParentKeyField];
                        }
                    }

                    this.data = data;
                    this.updateContent();
                }, {
                onError: response => {
                    this.displayError(response?.Error?.Message);
                }
            });
        }

        buildDiagram() {
            this.element.html(`${this.options.DisplayOverview ? `<style>
   #overviewDiv {
        position: relative;
        width: 200px;
        height: 100px;
        top: -120px;
        left: 10px;
        background-color: #f2f2f2;
        z-index: 300;
        border: solid 1px #7986cb;
    }
</style>` : ""}
<div id="VisualizerPage" class="s-DataGrid flex-layout" style="height: 100%; border: none;">
    <div id="VisualizerPanel" style="height: 100%;">
        <div class="report-box" style="position: relative;height: 100%;">
            <div id="diagramDiv" style="height:100%;width:100%;">
            </div>
        </div>
        ${this.options.DisplayOverview ? `<div id="overviewDiv" style="display:none"></div>` : ""}
    </div>
</div>`);

            this.diagram = this._(go.Diagram, "diagramDiv", {
                padding: 10
            });
        }

        buildDiagramLayout() {
            this.diagram.initialAutoScale = go.Diagram.UniformToFill;

            this.diagram.layout = this._(go.LayeredDigraphLayout,
                {
                    direction: 90,
                    layerSpacing: 25,
                    columnSpacing: 10,
                    cycleRemoveOption: go.LayeredDigraphLayout.CycleDepthFirst,
                    initializeOption: go.LayeredDigraphLayout.LayerOptimalLinkLength,
                    aggressiveOption: go.LayeredDigraphLayout.InitDepthFirstOut,
                    layeringOption: go.LayeredDigraphLayout.LayerLongestPathSource,
                    packOption: 7,
                    setsPortSpots: true
                });

            if (this.options.DisplayOverview) {
                this._(go.Overview, "overviewDiv", {
                    observed: this.diagram,
                    contentAlignment: go.Spot.Center
                });
            }

            this.diagram.linkTemplate =
                this._(go.Link,
                    { routing: go.Link.Orthogonal, corner: 5, selectable: false, fromEndSegmentLength: 5, toEndSegmentLength: 15 },
                    this._(go.Shape, { strokeWidth: 3, stroke: this.graphTheme.EdgeColour ?? "#626262" }),
                    this._(go.Shape, { toArrow: "OpenTriangle", stroke: this.graphTheme.EdgeColour ?? "#626262" }));

            let nodeTemplate =
                this._(
                    go.Node,
                    "Auto",
                    this._(
                        go.Panel,
                        "Auto",
                        this._(
                            go.Shape,
                            { strokeWidth: 1, name: "nodeShape", fill: this.options.NodeBackgroundColor ?? this.graphTheme.NodeColour ?? "white", stroke: this.graphTheme.NodeBorderColour ?? 'black' },
                            this.options.NodeBackgroundColorField ? new go.Binding("fill", this.options.NodeBackgroundColorField) : {},
                            new go.Binding("figure", "RoundedRectangle"),
                        ),
                        this._(
                            go.TextBlock,
                            { margin: this.options.NodePadding ?? 5, font: `${this.options.NodeFontSize ?? 12}px Verdana`, stroke: this.options.NodeFontColor ?? this.graphTheme.NodeTextColour ?? "black", name: "nodeText" },
                            this.options.NodeFontColorField ? new go.Binding("stroke", this.options.NodeFontColorField) : {},
                            new go.Binding("text", this.options.LabelField ?? Object.keys(this.data[0])[0])
                        )
                    )
                );

            this.diagram.nodeTemplate = nodeTemplate;
        }

        addDiagramEvents() {
            if (this.options.ClickUrl)
                this.diagram.addDiagramListener("ObjectSingleClicked", this.onNodeClick.bind(this));
        }

        buildDiagramModelWithData() {
            this.diagram.model = this._(go.TreeModel, {
                nodeKeyProperty: this.options.KeyField,
                nodeParentKeyProperty: this.options.ParentKeyField,
                nodeDataArray: this.data,
            });
        }

        displayError(message: string) {
            if (message && this.options.__designer)
                Q.notifyError(message);

            this.element.html('<div class="dash-widget-broken"><i class="fa fa-bug"></i></div>')
                .children().attr('title', message);
        }

        protected updateContent(): void {
            this.element.html('');

            if (!this.data)
                return;

            this.buildDiagram()
            this.buildDiagramLayout();
            this.addDiagramEvents();
            this.buildDiagramModelWithData();

            this.element.find('#diagramDiv').css({ backgroundColor: this.options.BackgroundColor ?? "transparent" }).show();

            if (this.options.DisplayOverview)
                this.element.find('#overviewDiv').show();
        }
    }
}